import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "background" }

import CookiesPrivacy from "@/components/cookies/cookiesPrivacy.vue";
import LoaderOverlay from "@/components/loader/loader.vue";
import GlobalError from "@/components/globalError/GlobalError.vue";
import LoginModal from "@/components/auth/LoginModal.vue";
import { useUIStore } from "@/stores/useUIStore";


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const uiStore = useUIStore();

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(CookiesPrivacy),
    _createVNode(_component_router_view),
    _createVNode(GlobalError),
    _createVNode(LoginModal),
    _createVNode(LoaderOverlay, {
      active: _unref(uiStore).loading
    }, null, 8, ["active"])
  ]))
}
}

})